import type { BraintreeContextValue } from './Braintree.types';

export const DEFAULT_BRAINTREE_CONTEXT_VALUE = {
  isLoading: false,
  error: null,
  client: undefined,
  instance: undefined,
  setInstance: () => { },
} as const satisfies BraintreeContextValue;
